import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from 'react';
import styles from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/edge-gradients/styles.module.css';
import type { SpartanProductExteriorThreesixtyBackground } from '@/app/lcv/components/sections/spartan/products/exterior/threesixty/types';
interface SpartanProductExteriorThreesixtyEdgeGradientsProps {
  background?: SpartanProductExteriorThreesixtyBackground;
}
interface EdgeGradientStyle extends CSSProperties {
  '--edge-top-color'?: string;
  '--edge-bottom-color': string;
}
export const SpartanProductExteriorThreesixtyEdgeGradients = t0 => {
  const $ = _c(8);
  const {
    background
  } = t0;
  if (typeof background !== "object" || background === null) {
    return null;
  }
  const {
    topEdgeColor,
    bottomEdgeColor
  } = background;
  let t1;
  if ($[0] !== topEdgeColor) {
    t1 = topEdgeColor ? {
      "--edge-top-color": topEdgeColor
    } : {};
    $[0] = topEdgeColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== bottomEdgeColor || $[3] !== t1) {
    t2 = {
      ...t1,
      "--edge-bottom-color": bottomEdgeColor
    };
    $[2] = bottomEdgeColor;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const style = t2;
  const t3 = topEdgeColor ? "" : undefined;
  let t4;
  if ($[5] !== style || $[6] !== t3) {
    t4 = <div className={styles.edgeStack} style={style} data-has-top-edge={t3} aria-hidden={true} />;
    $[5] = style;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};